import styles from '../../styles/simpleSlider.module.scss';

const BtnSlider = ({ direction, moveSlider }) => {
    return (
        <button
            className={direction === 'next' ? `${styles.btnSlider} ${styles.next}` : `${styles.btnSlider} ${styles.prev}`}
            onClick={moveSlider}
        >
            <img src={direction === 'next' ? "/services/delivery/next.webp" : "/services/delivery/prev.webp"} alt="Arrow" />
        </button>
    )
};

export default BtnSlider;
